import * as React from 'react';

export type IconName =
  | 'home' | 'sparkle' | 'sparkles' | 'grid' | 'chart' | 'bell' | 'bell2' | 'search' | 'settings'
  | 'user' | 'users' | 'package' | 'inbox' | 'folder' | 'layers' | 'car' | 'tag' | 'megaphone'
  | 'chat' | 'chevronRight' | 'chevronLeft' | 'chevronDown' | 'chevronUp' | 'arrowUpRight'
  | 'arrowRight' | 'arrowUp' | 'arrowDown' | 'plus' | 'minus' | 'x' | 'check' | 'sun' | 'moon'
  | 'sliders' | 'sliders2' | 'flag' | 'info' | 'filter' | 'plusCircle' | 'dots' | 'dotsV' | 'drag'
  | 'sidebar' | 'expand' | 'bookmark' | 'refresh' | 'history' | 'eye' | 'eyeOff' | 'star' | 'fire'
  | 'bolt' | 'target' | 'book' | 'code' | 'clock' | 'download' | 'share' | 'link' | 'globe' | 'pin'
  | 'play' | 'pause' | 'funnel' | 'calendar' | 'activity' | 'map' | 'trending' | 'spinner'
  | 'diamond' | 'rocket' | 'lightbulb' | 'notebook' | 'palette' | 'receipt' | 'cog' | 'shieldCheck'
  | 'flame' | 'cube' | 'helpCircle' | 'at' | 'locked' | 'coin' | 'trash' | 'edit' | 'copy'
  | 'spark2' | 'chartBar' | 'phone' | 'key';

export interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  weight?: number;
}

const PATHS: Record<IconName, React.ReactNode> = {
  home: <path d="M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1h-5v-7h-6v7H4a1 1 0 01-1-1v-9.5z" />,
  sparkle: <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />,
  sparkles: <path d="M9 4l1.4 3.6L14 9l-3.6 1.4L9 14l-1.4-3.6L4 9l3.6-1.4L9 4zM18 13l.8 2.2 2.2.8-2.2.8L18 19l-.8-2.2L15 16l2.2-.8L18 13z" />,
  grid: <><rect x="3.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="13.5" width="7" height="7" rx="1.5" /></>,
  chart: <><path d="M3 20V4M3 20h18" /><path d="M7 16l4-5 3 3 5-7" /></>,
  bell: <><path d="M6 8a6 6 0 1112 0c0 5 2 6 2 8H4c0-2 2-3 2-8zM10 20a2 2 0 004 0" /></>,
  bell2: <><path d="M6 8a6 6 0 0112 0v5l2 3H4l2-3V8z" /><path d="M10 19a2 2 0 004 0" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M16 16l4 4" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33h0a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51h0a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82h0a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></>,
  users: <><circle cx="9" cy="8" r="3.5" /><path d="M2 20c0-3.9 3.1-7 7-7s7 3.1 7 7" /><circle cx="17" cy="6" r="3" /><path d="M14 13.5c1-.3 2-.5 3-.5 3.3 0 6 2.7 6 6" /></>,
  package: <path d="M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4M21 7l-9 4M12 11v10" />,
  inbox: <path d="M3 14h5l1 3h6l1-3h5M5 4h14l2 10v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6L5 4z" />,
  folder: <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />,
  layers: <path d="M12 2l9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5" />,
  car: <><path d="M5 17h14M5 17l1.5-5.5A2 2 0 018.4 10h7.2a2 2 0 011.9 1.5L19 17M5 17v3a1 1 0 001 1h2a1 1 0 001-1v-3M19 17v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3" /><circle cx="8" cy="14.5" r="1" /><circle cx="16" cy="14.5" r="1" /></>,
  tag: <><path d="M21 12.5L12.5 21a1.5 1.5 0 01-2 0L3 13.5V4a1 1 0 011-1h9.5L21 10.5a1.4 1.4 0 010 2z" /><circle cx="8" cy="8" r="1.5" /></>,
  megaphone: <path d="M3 11v2a2 2 0 002 2h1l3 5h2v-5l8 3V6l-8 3H5a2 2 0 00-2 2z" />,
  chat: <path d="M21 15a2 2 0 01-2 2H8l-5 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" />,
  chevronRight: <path d="M9 6l6 6-6 6" />,
  chevronLeft: <path d="M15 6l-9 6 9 6" />,
  chevronDown: <path d="M6 9l6 6 6-6" />,
  chevronUp: <path d="M18 15l-6-6-6 6" />,
  arrowUpRight: <path d="M7 17L17 7M9 7h8v8" />,
  arrowRight: <path d="M5 12h14M13 5l7 7-7 7" />,
  arrowUp: <path d="M12 19V5M5 12l7-7 7 7" />,
  arrowDown: <path d="M12 5v14M5 12l7 7 7-7" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  x: <path d="M18 6L6 18M6 6l12 12" />,
  check: <path d="M5 12l5 5L20 7" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4l1.4-1.4M17 7l1.4-1.4" /></>,
  moon: <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z" />,
  sliders: <><path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h14M18 18h2" /><circle cx="16" cy="6" r="2" /><circle cx="8" cy="12" r="2" /><circle cx="16" cy="18" r="2" /></>,
  sliders2: <path d="M3 6h18M6 12h12M9 18h6" />,
  flag: <path d="M5 21V4M5 4h14l-3 5 3 5H5" />,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 8v.01M11 12h1v4h1" /></>,
  filter: <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z" />,
  plusCircle: <><circle cx="12" cy="12" r="9" /><path d="M12 8v8M8 12h8" /></>,
  dots: <><circle cx="5" cy="12" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="19" cy="12" r="1.2" /></>,
  dotsV: <><circle cx="12" cy="5" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="12" cy="19" r="1.2" /></>,
  drag: <><circle cx="9" cy="6" r="1.2" /><circle cx="15" cy="6" r="1.2" /><circle cx="9" cy="12" r="1.2" /><circle cx="15" cy="12" r="1.2" /><circle cx="9" cy="18" r="1.2" /><circle cx="15" cy="18" r="1.2" /></>,
  sidebar: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" /></>,
  expand: <path d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5" />,
  bookmark: <path d="M6 21V5a2 2 0 012-2h8a2 2 0 012 2v16l-6-4-6 4z" />,
  refresh: <path d="M3 12a9 9 0 0115-6.7L21 8M21 4v4h-4M21 12a9 9 0 01-15 6.7L3 16M3 20v-4h4" />,
  history: <><path d="M3 12a9 9 0 1015-6.7L21 8M21 3v5h-5" /><path d="M12 7v5l3 2" /></>,
  eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></>,
  eyeOff: <path d="M2 12s4-7 10-7c2 0 3 .5 4 1M22 12s-4 7-10 7c-2 0-3-.5-4-1M3 3l18 18" />,
  star: <path d="M12 3l2.6 5.7L21 9.5l-4.5 4.4 1.1 6.3L12 17l-5.6 3.2 1.1-6.3L3 9.5l6.4-.8L12 3z" />,
  fire: <path d="M12 21c-4 0-7-3-7-7 0-2 1-3 1-3-1 0 1-3 4-5 0 3 4 4 4 8 1 0 2-1 2-3 2 1 3 3 3 6 0 4-3 4-7 4z" />,
  bolt: <path d="M13 3L4 14h7l-1 7 9-11h-7l1-7z" />,
  target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></>,
  book: <><path d="M4 4a2 2 0 012-2h13v18H6a2 2 0 00-2 2V4z" /><path d="M4 20a2 2 0 012-2h13" /></>,
  code: <path d="M8 6l-5 6 5 6M16 6l5 6-5 6M14 4l-4 16" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  download: <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />,
  share: <><circle cx="6" cy="12" r="3" /><circle cx="18" cy="6" r="3" /><circle cx="18" cy="18" r="3" /><path d="M8.7 10.7l6.6-3.4M8.7 13.3l6.6 3.4" /></>,
  link: <path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1" />,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" /></>,
  pin: <path d="M9 4h6l-1 6 4 4H6l4-4-1-6zM12 14v7" />,
  play: <path d="M6 4l14 8-14 8V4z" />,
  pause: <path d="M7 4v16M17 4v16" />,
  funnel: <path d="M4 5h16l-6 8v6l-4-2v-4L4 5z" />,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>,
  activity: <path d="M3 12h4l3-8 4 16 3-8h4" />,
  map: <path d="M9 4l-6 2v14l6-2 6 2 6-2V4l-6 2-6-2zM9 4v14M15 6v14" />,
  trending: <path d="M3 17l6-6 4 4 8-8M14 7h7v7" />,
  spinner: <path d="M12 3a9 9 0 019 9" strokeLinecap="round" />,
  diamond: <path d="M12 2l10 10-10 10L2 12 12 2z" />,
  rocket: <><path d="M5 19l-1 3 3-1M5 19c2-5 4-7 9-12 3-3 7-3 7-3s0 4-3 7c-5 5-7 7-12 9z" /><path d="M9 14l1 4M14 9l4 1" /></>,
  lightbulb: <path d="M9 18h6M10 21h4M9 14a4 4 0 116 0c0 2-1 3-1 4H10c0-1-1-2-1-4z" />,
  notebook: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M9 3v18M4 8h5M4 12h5M4 16h5" /></>,
  palette: <><path d="M12 21a9 9 0 110-18 8 8 0 018 8c0 4-3 4-5 4h-2a2 2 0 00-2 3v.5A2.5 2.5 0 0112 21z" /><circle cx="7" cy="11" r="1" /><circle cx="11" cy="7" r="1" /><circle cx="16" cy="9" r="1" /></>,
  receipt: <><path d="M5 3l1 2 2-2 2 2 2-2 2 2 2-2 2 2 1-2v18l-1-2-2 2-2-2-2 2-2-2-2 2-2-2-1 2V3z" /><path d="M8 9h8M8 13h8M8 17h5" /></>,
  cog: <><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M21 12h-3M6 12H3M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1M18.4 18.4l-2.1-2.1M7.7 7.7L5.6 5.6" /></>,
  shieldCheck: <><path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" /></>,
  flame: <path d="M12 21c-4 0-7-3-7-7 0-2 2-4 2-6 1 1 2 1 2 3 2-1 3-3 3-7 4 1 7 5 7 9 0 4-3 8-7 8z" />,
  cube: <><path d="M3 8l9-5 9 5v8l-9 5-9-5V8z" /><path d="M3 8l9 5 9-5M12 13v10" /></>,
  helpCircle: <><circle cx="12" cy="12" r="9" /><path d="M9 9a3 3 0 016 0c0 2-3 2-3 4M12 17v.01" /></>,
  at: <><circle cx="12" cy="12" r="4" /><path d="M16 8v5a3 3 0 006 0v-1a9 9 0 10-3.6 7.2" /></>,
  locked: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></>,
  coin: <><circle cx="12" cy="12" r="9" /><path d="M14 9h-3a1.5 1.5 0 000 3h2a1.5 1.5 0 010 3H10M12 7v2M12 15v2" /></>,
  trash: <path d="M5 6h14M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2M6 6l1 14a1 1 0 001 1h8a1 1 0 001-1l1-14" />,
  edit: <><path d="M4 20h4l11-11-4-4L4 16v4z" /><path d="M14 6l4 4" /></>,
  copy: <><rect x="8" y="8" width="13" height="13" rx="2" /><path d="M16 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v9a2 2 0 002 2h3" /></>,
  spark2: <path d="M5 13h4v8h6v-8h4l-7-10-7 10z" />,
  chartBar: <path d="M4 20V10M10 20V4M16 20v-8M22 20H2" />,
  phone: <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />,
  key: <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.78 7.78 5.5 5.5 0 017.78-7.78zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />,
};

export function Icon({ name, size = 16, weight = 1.6, ...props }: IconProps) {
  const d = PATHS[name] ?? PATHS.helpCircle;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={weight}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={props['aria-label'] ? undefined : true}
      {...props}
    >
      {d}
    </svg>
  );
}
